module.exports = __webpack_public_path__ + "static/media/IMG_4358a.a32a2fdf.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/IMG_4358a.JPG
// module id = 118
// module chunks = 0